import React, { useEffect } from 'react';
import { Modal } from 'rsuite';
import PropTypes from 'prop-types';
import '../../styles/rsuite.min.css';
import { VimePlayer } from '..';
import { useIntl } from 'react-intl';
import css from './VideoPlayerModal.module.css';
import { useHistory, useLocation } from 'react-router-dom';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import { STORAGE_VIDEO_KEY } from '../../util/constants';
import { useDispatch } from 'react-redux';

const VideoPlayerModal = ({ isOpen, toggleModal, guideData, viewport }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const history = useHistory();
  const isMobileLayout = viewport.width > 0 && viewport.width < 1024;
  const location = useLocation();
  const videoResumeTime = location.state?.resumeTime ?? 0;

  useEffect(() => {
    if (isOpen) {
      localStorage.setItem('videoSlug', JSON.stringify(guideData?.slug));
    } else {
      localStorage.removeItem('videoSlug');
      const stored = localStorage.getItem(STORAGE_VIDEO_KEY);
      const storedArray = stored ? JSON.parse(stored) : [];

      const sortedVideos = storedArray
        .sort((a, b) => new Date(b.added) - new Date(a.added))
        .slice(0, 3);

      localStorage.setItem(STORAGE_VIDEO_KEY, JSON.stringify(sortedVideos));

      dispatch(
        updateProfile({
          privateData: {
            remainingVideos: sortedVideos,
          },
        })
      );
    }
  }, [isOpen]);

  const onCloseModal = () => {
    history.push(location.pathname);
    toggleModal();
  };

  return (
    <Modal open={isOpen} onClose={onCloseModal} size={isMobileLayout ? 'full' : 'lg'}>
      <Modal.Header>
        <Modal.Title>{guideData?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={css.videoPlayerWrapper}>
          {guideData?.videoURL ? (
            <VimePlayer
              videoURL={guideData?.videoURL}
              poster={guideData?.thumbnail}
              title={guideData?.title}
              slug={guideData?.slug}
              intl={intl}
              viewport={viewport}
              resumeTime={videoResumeTime}
            />
          ) : (
            <p>
              {intl.formatMessage({
                id: 'VideoPlayer.noVideoURL',
              })}
            </p>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

VideoPlayerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired, // Boolean to control modal visibility
  toggleModal: PropTypes.func.isRequired, // Function to toggle modal visibility
  videoUrl: PropTypes.string, // URL of the video to be displayed
};

export default VideoPlayerModal;
